import { ApiRequest } from "@/api/types";
export type ValidateKey = keyof typeof formConfig;

export const initialPartnerUser: ApiRequest.CreateManagedPartnerUser = {
  name: "",
  email: "",
  admin: false
};

export const formConfig = {
  name: {
    label: "ユーザー名",
    placeholder: "",
    help: "",
    required: true,
    maxLength: 255
  },
  email: {
    label: "メールアドレス",
    placeholder: "",
    help: "",
    required: true,
    maxLength: 255,
    isEmail: true
  },
  password: {
    label: "パスワード",
    placeholder: "",
    help: "",
    maxLength: 255
  }
};
